import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ExperianQuestion, ConfirmIndentityRequest, Answer } from 'src/models/question';
import QuestionSet from './QuestionSet';
import Workflow from 'src/models/workflow';
import { RegistrationStep } from '../../utils/constValues';
import { getCurrentStepRouter, setAttemptCounter } from 'src/utils/workflow';
import { WorkflowContext } from 'src/utils/constValues';
import { getWorkflowContextData, removeWorkflowContextData } from 'src/utils/workflow';
import { retryAllowed, /*workflowAllowedRetry,*/ workflowPermanentFail, clearSessionStorage } from 'src/utils/workflow';
import PopupConfirm from 'src/components/shared/PopupConfirm';

export interface StateFromProps {
    registrationId: string;
    sessionId: string;
    questions: Array<ExperianQuestion>;

    submitting: boolean;
    submitted: boolean;
    isPass: boolean;

    workflow: Workflow;
    checkRetry: boolean;
    // errorMessage: string;
}

export interface DispatchFromProps {
    submitExperianAnswers: (confirmIdentityAnswer: ConfirmIndentityRequest) => void;
    updateWorkflow: (workflow: Workflow) => void;

    //New Step02
    submitExperianQuestions: (confirmIdentityAnswer: ConfirmIndentityRequest) => void;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

export interface State {
    hasError: boolean;
    showPopup: boolean;
    answers: Array<Answer>;
}

class Experian extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        window.document.title = 'Experian';

        this.state = this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            hasError: false,
            showPopup: false,
            answers: []
        };
    }

    componentDidMount() {
        setAttemptCounter('0', false);
    }

    componentWillReceiveProps(nextProps: Props) {
        // if (nextProps.submitted && nextProps.isPass
        //     && nextProps.workflow.isCurrentStepFinished
        //     && nextProps.workflow.currentStep === RegistrationStep.ContractAgreement) {
        //     removeWorkflowContextData(WorkflowContext.EXPERIAN_QUESTIONS.toString());
        //     removeWorkflowContextData(WorkflowContext.EXPERIAN_SESSION_ID.toString());
        //     removeWorkflowContextData(WorkflowContext.USER_INFO.toString());
        //     this.props.history.push(getCurrentStepRouter(nextProps.workflow));
        // }

        // New Step02
        if (nextProps.submitted && nextProps.isPass
            && nextProps.workflow.isCurrentStepFinished
            && nextProps.workflow.currentStep === RegistrationStep.ClinicInformation) {
            removeWorkflowContextData(WorkflowContext.EXPERIAN_QUESTIONS.toString());
            removeWorkflowContextData(WorkflowContext.EXPERIAN_SESSION_ID.toString());
            removeWorkflowContextData(WorkflowContext.USER_INFO.toString());
            this.props.history.push(getCurrentStepRouter(nextProps.workflow));
        }

        if (this.props.checkRetry !== nextProps.checkRetry && nextProps.checkRetry) {
            if (retryAllowed(false)) {
                // this.props.updateWorkflow(workflowAllowedRetry());
                // this.props.history.push('/registration/completewithfailallowedretry');
                // if (nextProps.errorMessage && !isNullOrEmpty(nextProps.errorMessage)) {
                //     this.setState({ showPopup: true });
                // }
                this.setState({ showPopup: true });
            } else {
                console.log('Permanent fail');
                this.props.updateWorkflow(workflowPermanentFail());
                clearSessionStorage();
                this.props.history.push('/registration/completewithpermanentfail');
            }
        }
    }

    handleChange = (value: string, field: string): void => {
        let selectedAnswer = JSON.parse(value) as Answer;

        this.setState((prevState: State) => {
            let answersVM: Array<Answer> = [...prevState.answers];
            answersVM[selectedAnswer.questionIndex] = selectedAnswer;

            return {
                ...prevState,
                answers: answersVM
            };
        });
    }

    submitAnswers = (): void => {
        const { registrationId, sessionId, questions } = this.props;
        const { hasError, answers } = this.state;
        if (!hasError && questions && /*questions.length > 0 &&*/ answers) {
            if (Object.keys(answers).length === questions.length) {
                let confirmIdentityAnswer: ConfirmIndentityRequest = {
                    registrationId: registrationId,
                    sessionId: sessionId,
                    questions: questions,
                    answers: answers,
                    userInfo: getWorkflowContextData(WorkflowContext.USER_INFO)
                };
                //this.props.submitExperianAnswers(confirmIdentityAnswer);
                //New Step02
                this.props.submitExperianQuestions(confirmIdentityAnswer);
            }
            else {
                alert(`You must select an answer for each question!`);
            }
        }
        else {
            alert(`Has errors occurred!`);
        }
    }
    confirm = (): void => {
        this.setState({ showPopup: false });
    }

    render() {
        const { submitting, questions } = this.props;
        const { answers, showPopup } = this.state;
        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <h5 className="card-title-sp">Experian Questionaire</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            <div className="autoscroll-1 border-cont">
                                                                {
                                                                    submitting ?
                                                                        <div className="loading-center">
                                                                            <table className="table table-borderless">
                                                                                <tbody className="spinner-bg d-flex">
                                                                                    <tr className="text-center">
                                                                                        <td className="alert alert-info" role="alert">
                                                                                            <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />Submitting...</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        :
                                                                        <QuestionSet
                                                                            questions={questions}
                                                                            answersIndex={(answers && answers.length > 0) ? answers.map(ans => ans.answerIndex) : []}
                                                                            handleChange={this.handleChange}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" disabled={submitting} onClick={this.submitAnswers}><i className="fa fa-arrow-right" /> Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PopupConfirm
                    showPopup={showPopup}
                    shouldHideNoButton={true}
                    customTextYesButton={' OK'}
                    loading={false}
                    inStepTwo={true}
                    onCancel={() => { }}
                    executeFunction={this.confirm}
                />
            </main>
        );
    }
}

export default Experian;


// WEBPACK FOOTER //
// ./src/components/Experian/Experian.tsx